<template v-slot:no-data>
    <v-card class="rounded-xl elevation-2 overflow-hidden border-light">
        <div style="display: none;">
            <s-select-definition :def="1045" @getDataInitial="getDataTypeCost($event)" />
        </div>
        <!-- ── Cabecera Premium Optimizada ── -->
        <!-- <div class="header-premium py-5 px-6 d-flex align-center flex-wrap">
            <div class="d-flex align-center">
                <div class="icon-box mr-4 elevation-3">
                    <v-icon color="white">mdi-file-clock-outline</v-icon>
                </div>
                <div>
                    <h2 class="text-h5 font-weight-black white--text mb-0 tracking-tight">Historial de Pagos</h2>
                    <p class="caption white--text text--lighten-3 mb-0 opacity-80">
                        Administración de registros y generación de comprobantes de servicio
                    </p>
                </div>
            </div>
            <v-spacer></v-spacer>
            <div class="action-buttons d-flex align-center mt-3 mt-sm-0">
                <v-btn color="white" light depressed class="elevation-2 rounded-lg primary--text"
                    @click="calculateOrderService()" :disabled="selected.length === 0">
                    <v-icon left color="primary">mdi-file-document-edit</v-icon>
                    Orden de Compra
                    <v-chip v-if="selected.length > 0" x-small color="primary" class="ml-2 px-1 white--text">
                        {{ selected.length }}
                    </v-chip>
                </v-btn>

                <v-btn icon small class="refresh-btn-glass ml-2" @click="refreshGrid()" title="Refrescar datos">
                    <v-icon small color="white">mdi-refresh</v-icon>
                </v-btn>
            </div>
        </div> -->

        <div class="pa-0 bg-slate-50">
            <s-crud ref="gridPaymentRecords" :filter="filter" :config="config" addNoFunction
                @rowSelected="rowSelected($event)" search-input no-full :groupBy="'RUC'" height="65dvh"
                :single-row="false" :rowDefault="false" click-row-no-select show-count class="rounded-lg">

                <template v-slot:options>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn text small v-on="on" @click="calculateOrderService()"
                                :disabled="selected.length === 0">
                                <v-icon style="font-size:18px;">mdi-file-document-edit</v-icon>
                            </v-btn>
                        </template>
                        <span>Generar Orden de Compra</span>
                    </v-tooltip>
                </template>


                <!-- ── Filtros Optimizados ── -->
                <template v-slot:filter>
                    <div class="filter-wrapper px-3 pb-2">
                        <v-row dense class="align-center">
                            <!-- <v-col lg="2" md="4" cols="12">
                                <s-date label="Fecha Inicio" v-model="filter.DateBegin" outlined dense
                                    hide-details></s-date>
                            </v-col>

                            <v-col lg="2" md="4" cols="12">
                                <s-date label="Fecha Final" v-model="filter.DateEnd" outlined dense
                                    hide-details></s-date>
                            </v-col> -->

                            <v-col lg="2" md="4" cols="12">
                                <s-select label="Año" :items="years" outlined hide-details dense clearable
                                    v-model="filter.PymYear"></s-select>
                            </v-col>
                            <v-col lg="2" md="4" cols="12">
                                <s-periods label="Periodo Semana" v-model="PymWeek" :year="filter.PymYear" :type="1"
                                    clearable return-object @input="changeWeek"></s-periods>
                            </v-col>
                        </v-row>
                    </div>
                </template>

                <!-- ── Slots de Columnas Customizadas ── -->
                <!-- Selección Condicional -->
                <template v-slot:item.data-table-select="{ item, isSelected, select }">
                    <div class="d-flex justify-start">
                        <div v-if="!item.OrdDocumentNumber">
                            <v-simple-checkbox :value="isSelected" color="primary" @input="select($event)" />
                        </div>
                        <div v-else class="d-flex justify-center flex-column align-center p-1">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn outlined x-small color="warning" @click="showOrder(item)" v-bind="attrs"
                                        v-on="on">
                                        <v-icon x-small>mdi-file-check</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ item.OrdDocumentNumber }}</span>
                            </v-tooltip>
                        </div>
                        <v-chip small :color="`${getColor(item.PymTypeTransport)} lighten-5`"
                            style="font-size: 0.75rem;"
                            :class="`${getColor(item.PymTypeTransport)}--text text--darken-4`"
                            class="font-weight-black border shadow-sm pa-1 px-2 rounded-lg">
                            {{ item.PymTypeTransportName }}
                        </v-chip>
                    </div>
                </template>

                <!-- Estado con Chips Modernos -->
                <template v-slot:PymState="{ row }">
                    <v-chip :color="row.OrdDocumentNumber == null ? 'amber lighten-5' : 'primary lighten-5'"
                        :class="row.OrdDocumentNumber == null ? 'amber--text text--darken-3' : 'primary--text text--darken-2'"
                        x-small label class="rounded-lg pa-3">
                        <v-icon left x-small>
                            {{ row.OrdDocumentNumber == null ? 'mdi-clock-outline' : 'mdi-check-circle' }}
                        </v-icon>
                        {{ row.OrdDocumentNumber == null ? 'Pendiente' : row.OrdDocumentNumber }}
                    </v-chip>
                </template>

                <!-- RUC y Razón Social elegante -->
                <template v-slot:RUC="{ row }">
                    <div class="d-flex flex-column py-1">
                        <span class="caption grey--text text--darken-1 font-weight-medium">{{ row.RUC }}</span>
                        <span class="body-2 font-weight-bold text-truncate" style="max-width: 250px;"
                            :title="row.BusinessName">
                            {{ row.BusinessName }}
                        </span>
                    </div>
                </template>

                <!-- Fecha Formateada -->
                <template v-slot:ScheduleDate="{ row }">
                    <div class="d-flex align-center">
                        <v-icon small color="grey" class="mr-1">mdi-calendar</v-icon>
                        <span class="body-2">{{ $fun.formatDateView(row.ScheduleDate) }}</span>
                    </div>
                </template>

                <!-- Cultivo y Variedad -->
                <template v-slot:PymTypeCultiveName="{ row }">
                    <div class="text-center">
                        <div class="font-weight-black">{{ row.PymTypeCultiveName }}</div>
                        <div class="x-small-text grey--text">{{ row.PymTypeCropName }}</div>
                    </div>
                </template>

                <!-- Placa y Marca -->
                <template v-slot:TypeVehicleBrandName="{ row }">
                    <div class="text-center py-1">
                        <div class="">{{ row.TypeVehicleBrandName }}</div>
                        <div class="font-weight-black grey--text text--darken-1">{{ row.VehPlate }}</div>
                    </div>
                </template>

                <!-- Localidad y Zona -->
                <template v-slot:PymLocalityName="{ row }">
                    <div class="text-center">
                        <div class="font-weight-medium">{{ row.PymLocalityName }}</div>
                        <v-chip x-small class="font-weight-black border shadow-sm pa-1 rounded"
                            style="font-size: 0.75rem;letter-spacing: 0.35px;">
                            {{ row.PymZoneName }}
                        </v-chip>
                    </div>
                </template>

                <!-- Montos Monetarios -->
                <template v-slot:PymUnitPriceFruta="{ row }">
                    <span class="font-weight-medium">{{ formatoMonedaPE(row.PymUnitPriceFruta) }}</span>
                </template>

                <template v-slot:PymUnitPriceMaterial="{ row }">
                    <span class="font-weight-medium">{{ formatoMonedaPE(row.PymUnitPriceMaterial) }}</span>
                </template>

                <template v-slot:PymUnitExtraAmount="{ row }">
                    <span class="font-weight-medium orange--text text--darken-3">{{
                        formatoMonedaPE(row.PymUnitExtraAmount) }}</span>
                </template>

                <template v-slot:PymTransshipmentAmount="{ row }">
                    <span class="font-weight-medium purple--text">{{ formatoMonedaPE(row.PymTransshipmentAmount)
                    }}</span>
                </template>

                <template v-slot:PymTotalPaid="{ row }">
                    <v-chip small color="teal darken-2" dark class="font-weight-black elevation-1">
                        {{ formatoMonedaPE(row.PymTotalPaid) }}
                    </v-chip>
                </template>
                <template v-slot:PymReferralGuide="{ row }">
                    <div class="d-flex align-center">
                        <span>{{ row.PymReferralGuide }}</span>
                        <v-btn v-if="row.PymFilename" x-small icon @click="downloadPDF(row.PymFilename)">
                            <v-icon color="red darken-1" title="PDF disponible">
                                mdi-file-pdf-box
                            </v-icon>
                        </v-btn>
                    </div>
                </template>
            </s-crud>


            <!-- MODAL ORDEN DE COMPRA PREMIUM -->
            <div v-if="dialogOrder">
                <v-dialog v-model="dialogOrder" persistent width="100%">
                    <v-card>
                        <order-purchase-edit :typeOrder="3" :order="order" isStatusActive :isTransport="true"
                            :initialAttach1="order.zipFile" @onClose="onClose()"
                            @orderSaved="syncDetailsWithOrder"></order-purchase-edit>
                    </v-card>
                </v-dialog>
            </div>


            <div v-if="dialogOrderView">
                <v-dialog v-model="dialogOrderView" persistent width="100%">
                    <v-card>
                        <order-purchase-edit @onClose="dialogOrderView = false" :value="reqID" :order="{}" />
                    </v-card>
                </v-dialog>
            </div>
        </div>
    </v-card>
</template>

<script>
//Service
import _sPaymentRecordService from "@/services/Technicalassistance/TransportPaymentRecordService";
import _sReceptionSurveillance from "@/services/Technicalassistance/ReceptionSurveillanceService";
import _sPayment from "@/services/Technicalassistance/TransportPaymentService";
import TransportPaymentNew from "./TransportPaymentNew.vue";
import TransportPaymentEdit from "./TransportPaymentEdit.vue";
import PaymentAditional from "./PaymentAditional.vue";
import _sCosteService from "@/services/Technicalassistance/TransportCosteService";


import SSelectTransport from "@/components/HarvestSchedule/SSelectTransport";
import SPeriods from "../../../components/Utils/SPeriods.vue";
import OrderPurchaseEdit from "../../Logistics/OrderPurchase/OrderPurchaseEdit.vue";
import _sRequirement from "@/services/Logistics/RequirementService";
import _sSupplier from '@/services/Logistics/SupplierService';
import _GenUploadFiles from "@/services/General/GenUploadFiles";

export default {
    components: {
        TransportPaymentNew,
        TransportPaymentEdit,
        OrderPurchaseEdit,
        SSelectTransport,
        PaymentAditional,
        SPeriods
    },
    data: () => ({
        filter: {
            DateBegin: "",
            DateEnd: "",
            Search: "",
            PymYear: null,
            PymWeek: null
        },
        PymWeek: null,
        week: [],
        allItemsCenterCosts: [],
        itemsWeek: [],
        itemsTypeCost: [],
        dialog: false,
        dialogLoad: false,
        openAditional: false,
        dialogOrder: false,
        dialogOrderView: false,
        reqID: null,
        selectedSAP: [],
        order: { TypeOrder: 3, detail: [], zipFile: null },
        selected: [],
        config: {
            service: _sPaymentRecordService,
            model: {
                PymID: "ID",
                PymSubTotal: "decimal",
                PymAditionalAmount: "decimal",
                PymTotalPaid: "decimal",
            },
            headers: [
                { text: 'RUC', value: 'RUC', width: '250px' },
                { text: 'Razón Social', value: 'BusinessName', width: '250px' },
                { text: 'Fecha', value: 'ScheduleDate', width: '110px' },
                { text: 'Sem', value: 'PymWeek', align: 'center', width: '60px' },
                { text: 'Vehículo', value: 'TypeVehicleBrandName', width: '90px' },
                { text: 'Localidad', value: 'PymLocalityName', width: '100px' },
                { text: 'Cultivo', value: 'PymTypeCultiveName', align: 'center', width: '60px' },
                { text: 'Destino', value: 'PymDestinationName', width: '90px' },
                { text: 'Costo', value: 'PymSubTotal', align: 'end', width: '100px' },
                // { text: 'Material', value: 'PymUnitPriceMaterial', align: 'end', width: '100px' },
                { text: 'Adicional', value: 'PymAditionalAmount', align: 'end', width: '100px' },
                // { text: 'Trasbordo', value: 'PymTransshipmentAmount', align: 'end', width: '100px' },
                { text: 'Total', value: 'PymTotalPaid', align: 'end', width: '110px' },
                { text: 'Orden Compra', value: 'PymState', align: 'center', width: '150px' },
                { text: 'Guia Remisión', value: 'PymReferralGuide', align: 'center', width: '120px' },
                // { text: 'Notas', value: 'PymNotes', width: '250px' },
            ],
        },
    }),
    methods: {
        getDataTypeCost(items) {
            this.itemsTypeCost = items;
        },
        getColor(type) {
            switch (type) {
                case 1:
                    return "green";
                case 2:
                    return "orange";
                case 3:
                    return "warning";
                case 4:
                    return "purple";
                case 5:
                    return "blue";
                default:
                    return "primary";
            }
        },
        rowSelected(items) {
            this.selected = items || [];
        },
        async calculateOrderService() {
            if (this.selected.length === 0) {
                this.$fun.alert("No ha seleccionado ningún registro", "warning");
                return;
            }

            // Validar que todos los registros tengan el mismo RUC
            const uniqueRucs = [...new Set(this.selected.map(x => x.RUC))];

            if (uniqueRucs.length > 1) {
                this.$fun.alert("No se puede generar la orden: Los registros seleccionados deben pertenecer al mismo Proveedor (RUC).", "warning");
                return;
            }

            // Agrupar por semana
            //Llena el Combo Concepto de Servicio
            // _sRequirement.ConceptService(this.$fun.getUserID()).then((r) => {
            //     console.log({ concepts: r.data });
            // });

            // _sRequirement.AccountConceptService(this.ConName, this.$fun.getUserID()).then((res) => {
            //     console.log(res);
            // });


            const first = this.selected[0];

            if (first?.RUC) {
                const params = { Code: 'PT', TypeFilter: 1, Search: first.RUC }
                const res = await _sSupplier.SupplierByRuc(params, this.$fun.getUserID());
                if (res.status == 200 && res.data.length > 0) {
                    this.order.SupID = res.data[0].SupID;
                    this.order.SupName = res.data[0].SupName;
                    this.order.SupCode = res.data[0].SupID;
                }
            }
            this.order.ConID = null;
            this.order.TypeCurrency = 1;
            this.order.OrdDocRate = null;
            this.order.OrdDiscountPercentage = null;
            this.order.QuoteNumber = null;
            this.order.detail = this.processSelectedItems();

            // const guiasTranspFruta = [...new Set(this.selected.map(p => p.RcsNumberFerralGuideDriver))];//GRE transportista Fruta
            // const guiasTranspMat = [...new Set(this.selected.map(p => p.RcsNumberFerralGuideDriverMaterials))];//GRE Transportista Materiales
            // const guiasRemisionFruta = [...new Set(this.selected.map(p => p.RcsNumberReferralGuide))].flatMap(guide => [`${guide}.pdf`, `${guide}.xml`]); //GRE Fruta
            // const guiasRemisionMat = [...new Set(this.selected.map(p => p.RcsNumberFerralGuideMaterials))]; //GRE Materiales
            // const guiasCosecha = [...new Set(this.selected.map(p => p.RcsNumberHarvestGuide))]; //Guia Cosecha
            // const guias = [...new Set(this.selected.map(p => p.PymReferralGuide))];
            // const guides = [...new Set([...guiasTranspFruta, ...guiasTranspMat, ...guiasRemisionMat, ...guiasCosecha])].flatMap(guide => [`${guide}.pdf`, `${guide}.xml`]);
            const guides = [...new Set(this.selected.flatMap(p => [p.RcsPathGuidePdf, p.RcsPathGuideXml, p.RcsPathGuideMaterialsPdf, p.RcsPathGuideMaterialsXml, p.RcsNumberHarvestGuide + ".pdf"]).filter(Boolean))];
            const invoices = [...new Set(this.selected.flatMap(p => [p.PymPathInvoiceNumberPdf, p.PymPathInvoiceNumberXml]).filter(Boolean))];
            const guidesFacele = [...new Set(this.selected.flatMap(p => [p.PymPathReferralGuidePdf]).filter(Boolean))];
            // console.log(JSON.parse(JSON.stringify({ guides, invoices, guidesFacele })))

            const uniqueHvsIds = [...new Set(this.selected.map(item => item.HvsID).filter(id => id !== null && id !== undefined && id !== ''))];
            let guidesTransport = [];

            for (let i = 0; i < uniqueHvsIds.length; i++) {
                const response = await this.getGuidesTransportReception(uniqueHvsIds[i], this.$fun.getUserID());
                if (response.length > 0) {
                    guidesTransport.push(...response);
                }
            }
            
            // console.log(JSON.parse(JSON.stringify({ guidesTransport })))
            // Generar ZIP, descargarlo y conservar el File para pre-cargarlo en el modal
            if (guides.length > 0 || guidesTransport.length > 0 || invoices.length > 0) {
                await this.createZipPDFAnexos([...guides, ...guidesTransport], invoices, guidesFacele);
            }

            this.dialogOrder = true;
        },
        processSelectedItems() {
            const groups = {};
            const items = [...this.selected].sort((a, b) => a.PymTypeTransport - b.PymTypeTransport);
            // const items = [...this.selected].sort((a, b) => new Date(a.ScheduleDate) - new Date(b.ScheduleDate));

            items.forEach(item => {
                const week = item.PymWeek;
                const typeCultiveID = item.PymTypeCultive || 0; // ID para MANGO, PALTO
                const cropTypeID = item.PymTypeCrop || 0; // ID para CONVENCIONAL, ORGANICO
                const destID = item.PymDestinationID == null ? 1 : item.PymDestinationID; // ID para DESTINO
                const plate = item.VehPlate || ''; // Placa

                const frutaCost = (item.PymTypeTransport == 1) ? parseFloat(item.PymSubTotal || 0) : 0;
                const additionalCost = (item.PymTypeTransport == 1) ? parseFloat(item.PymAditionalAmount || 0) : 0;
                const materialCost = (item.PymTypeTransport == 2) ? parseFloat(item.PymTotalPaid || 0) : 0;
                const personalCost = (item.PymTypeTransport == 3) ? parseFloat(item.PymTotalPaid || 0) : 0;
                const trasbordoCost = (item.PymTypeTransport == 4) ? parseFloat(item.PymTotalPaid || 0) : 0;
                const extraCost = (item.PymTypeTransport == 5) ? parseFloat(item.PymTotalPaid || 0) : 0;
                const javas = (item.PymTypeTransport == 1) ? parseFloat(item.ActualCrates || 0) : 0;
                const destName = item.PymDestinationID == null ? 'FRESCOS' : item.PymDestinationName;

                // Agrupación por Tipo Transporte: [FRUTA + ADICIONALES]
                if (frutaCost > 0) {
                    const keyFruta = `${week}-${typeCultiveID}-${cropTypeID}-${destID}-FRUTA-${plate}`;
                    if (!groups[keyFruta]) {
                        groups[keyFruta] = {
                            week: week,
                            type: 'FRUTA',
                            totalAmount: 0,
                            javas: 0,
                            records: [],
                            plates: new Set(),
                            dates: [],
                            guides: new Set(),
                            typeTransport: item.PymTypeTransport,
                            localityID: item.PymLocality || 1,
                            locality: item.PymLocalityName || '',
                            zone: item.PymZoneName || '',
                            typeCultiveID: typeCultiveID, //MANGO, PALTO
                            typeCultive: item.PymTypeCultiveName || '', //MANGO, PALTO
                            cropTypeID: cropTypeID,
                            cropName: item.PymTypeCropName || 'FRUTA', //CONVENCIONAL, ORGANICO
                            baseNote: item.PymNotes || '',
                            destinationName: destName,
                            destinationID: destID
                        };
                    }
                    groups[keyFruta].totalAmount += frutaCost + additionalCost;
                    groups[keyFruta].javas += javas;
                    groups[keyFruta].records.push(item);
                    groups[keyFruta].plates.add(item.VehPlate);
                    groups[keyFruta].dates.push(item.ScheduleDate);
                    if (item.PymReferralGuide) groups[keyFruta].guides.add(item.PymReferralGuide);
                }

                // Agrupación por Tipo Transporte: [MATERIAL + TRASBORDO]
                if (materialCost > 0 || trasbordoCost > 0) {
                    const keyMaterial = `${week}-${cropTypeID}-${destID}-MATERIAL-${plate}`;
                    if (!groups[keyMaterial]) {
                        groups[keyMaterial] = {
                            week: week,
                            type: 'MATERIAL_TRASBORDO', //'MATERIAL_TRASBORDO',
                            totalAmount: 0,
                            javas: 0,
                            records: [],
                            plates: new Set(),
                            dates: [],
                            guides: new Set(),
                            typeTransport: 2,
                            localityID: item.PymLocality || 1,
                            locality: item.PymLocalityName || '',
                            zone: item.PymZoneName || '',
                            typeCultiveID: typeCultiveID,
                            typeCultive: item.PymTypeCultiveName || '',
                            cropTypeID: cropTypeID,
                            cropName: item.PymTypeCropName || 'MATERIAL',
                            baseNote: item.PymNotes || '',
                            destinationName: destName,
                            destinationID: destID
                        };
                    }
                    groups[keyMaterial].totalAmount += materialCost + trasbordoCost;
                    groups[keyMaterial].javas = 0;
                    groups[keyMaterial].records.push(item);
                    groups[keyMaterial].plates.add(item.VehPlate);
                    groups[keyMaterial].dates.push(item.ScheduleDate);
                    if (item.PymReferralGuide) groups[keyMaterial].guides.add(item.PymReferralGuide);
                }

                // Agrupación por Tipo Transporte: [extras]
                if (extraCost > 0) {
                    const keyExtras = `${week}-${cropTypeID}-${destID}-MATERIAL-${plate}`;
                    if (!groups[keyExtras]) {
                        groups[keyExtras] = {
                            week: week,
                            type: 'MATERIAL_EXTRA',
                            totalAmount: 0,
                            javas: 0,
                            records: [],
                            plates: new Set(),
                            dates: [],
                            guides: new Set(),
                            typeTransport: 4, //TRANSP. EXTRAS
                            localityID: item.PymLocality || 1,
                            locality: item.PymLocalityName || '',
                            zone: item.PymZoneName || '',
                            typeCultiveID: typeCultiveID,
                            typeCultive: item.PymTypeCultiveName || '',
                            cropTypeID: cropTypeID,
                            cropName: item.PymTypeCropName || 'EXTRAS',
                            baseNote: item.PymNotes || '',
                            destinationName: destName,
                            destinationID: destID
                        };
                    }
                    groups[keyExtras].totalAmount += extraCost;
                    groups[keyExtras].javas = 0;
                    groups[keyExtras].records.push(item);
                    groups[keyExtras].plates.add(item.VehPlate);
                    groups[keyExtras].dates.push(item.ScheduleDate);
                    if (item.PymReferralGuide) groups[keyExtras].guides.add(item.PymReferralGuide);
                }
            });

            // console.log(JSON.parse(JSON.stringify({ groups: groups })))

            return Object.values(groups)
                .sort((a, b) => (parseInt(a.destinationID) || 0) - (parseInt(b.destinationID) || 0))
                .map((group, i) => {
                    // Ordenar fechas para sacar min y max
                    const sortedDates = [...group.dates].sort((a, b) => new Date(a) - new Date(b));
                    const minDate = sortedDates[0];
                    const maxDate = sortedDates[sortedDates.length - 1];

                    let dateLabel = "";
                    const uniqueDates = [...new Set(sortedDates.map(d => this.$fun.formatDateView(d)))];

                    if (uniqueDates.length > 1) {
                        const days = uniqueDates.map(d => d.split('/')[0]);
                        const lastDay = days.pop();
                        const monthYear = this.$fun.formatDateView(sortedDates[sortedDates.length - 1]).substring(3).replace(/\//g, '-');
                        dateLabel = `${days.join(',')} y ${lastDay}-${monthYear}`;
                    } else {
                        dateLabel = this.$fun.formatDateView(sortedDates[0]).replace(/\//g, '-');
                    }

                    // Determinar tipo descripción
                    let typeDesc = 'TRASL.';
                    if (group.type === 'FRUTA') {
                        typeDesc = `TRASL. FRUTA ${group.typeCultive} ${group.cropName} ${group.destinationName} (${group.javas}JBS)`.toUpperCase();
                    } else if (group.type === 'MATERIAL_TRASBORDO') {
                        typeDesc = 'TRASL.DE MAT.COSECHA';
                    } else if (group.type === 'MATERIAL_EXTRA') {
                        typeDesc = 'TRASL.DE MAT.COSECHA';
                    } else if (group.type === 'MATERIAL') {
                        typeDesc = 'TRASL.DE MAT.COSECHA';
                    }

                    // Extraer o definir Categoría (EXPORTACION)
                    let category = '';
                    let extraInfo = ''; // Para conservar info en paréntesis si existe (ej: placa adicional)
                    if (group.destinationID == 1) {
                        category = '/EXPORTACION';
                    }
                    if (group.destinationID == 2) {
                        category = '/INDUSTRIA';
                    }

                    // Formato solicitado: SEM09/TRASL. MANGO FRESCO (687JBS ) /EXPORTACION/24-02-2026/CASMA-TGDE/BAC807
                    // Unir Localidad y Zona
                    const locZone = group.locality.toLowerCase() == group.zone.toLowerCase() ? group.locality : `${group.locality}-${group.zone}`.toUpperCase();
                    const platesStr = [...group.plates][0] || '';

                    let consolidatedDescription = `SEM${String(group.week).padStart(2, '0')}/${typeDesc}${extraInfo}/${category}/${dateLabel}/${locZone}/${platesStr}`.replace(/\/\/+/g, '/').toUpperCase();

                    let totalAmount = parseFloat(group.totalAmount || 0);
                    let quantity = parseFloat(1);
                    let taxPerc = parseFloat(18.00);
                    let price = parseFloat(totalAmount / 1.18);
                    let discountPerc = parseFloat(0);

                    let grossAmount = price * quantity;
                    let discountAmount = grossAmount * (discountPerc / 100);
                    let netSubTotal = grossAmount - discountAmount;
                    let taxAmount = netSubTotal * (taxPerc / 100);

                    let CceObject = null;
                    let BslObject = null;
                    let PrjObject = null;
                    const TypeCostObject = this.itemsTypeCost.find(x => x.DedValue == 2);
                    const account = this.allItemsCenterCosts.find(g =>
                        g.TypeZonLocation == group.localityID &&
                        g.Cultive == group.typeCultiveID &&
                        g.TypeCoste == group.typeTransport &&
                        g.TypeShip == group.destinationID &&
                        (group.typeTransport == 4 || g.TypeCultive == group.cropTypeID));
                    // console.log(JSON.parse(JSON.stringify({ account, group })))

                    if (account) {
                        CceObject = {
                            GenID: Number(account?.CceID), //9101102,
                            GenDescription: account?.CceName, //"Cosecha - Piura"
                            GenAbbreviation: null,
                            GenHelper: null,
                            GenValue: 0
                        }
                        BslObject = {
                            GenID: Number(account?.BslID), //115,
                            GenDescription: account?.BslName, //"Bolsa Cost Prod Cong",
                            GenAbbreviation: null,
                            GenHelper: null,
                            GenValue: 0
                        }
                        PrjObject = {
                            GenID: 0,
                            GenDescription: account?.PrjName,
                            GenAbbreviation: null,
                            GenHelper: account?.PrjCode,
                            GenValue: 0
                        }
                    }

                    return {
                        DerID: null,
                        ReqID: null,
                        ReqDocumentNumber: null,
                        DerNumLine: null,
                        ArtCode: null,
                        DerDescription: consolidatedDescription,
                        DerQuantity: null,
                        UnitMeasurement: null,
                        TypeCurrency: null,
                        DerAmount: null,
                        WhsID: null,
                        CceObject: CceObject,
                        CceID: CceObject?.GenID,
                        CceName: CceObject?.GenDescription,
                        CceCode: null,
                        BslObject: BslObject,
                        BslID: BslObject?.GenID,
                        BslName: BslObject?.GenDescription,
                        BslCode: null,
                        ReqAccount: null,
                        ReqDate: null,
                        ReqAttentionDate: null,
                        ReqAuthorizationDate: null,
                        DerQuantityServed: null,
                        DerObservation: consolidatedDescription,
                        PrjCode: PrjObject?.GenHelper,
                        PrjName: PrjObject?.GenDescription,
                        SisID: null,
                        SitID: null,
                        ComID: null,
                        TypeMaintenance: null,
                        TypePriority: null,
                        TypePriorityName: null,
                        DerStatus: null,
                        DerStatusName: null,
                        OrdID: null,
                        OrdDate: null,
                        TypeMaintenanceName: null,
                        TypeRequirement: 3,
                        AreID: null,
                        BeginDate: null,
                        EndDate: null,
                        ItmsGrpCod: null,
                        ItemsCod: null,
                        SitName: null,
                        ComName: null,
                        SisName: null,
                        TypeCost: TypeCostObject?.DedValue,
                        TypeCostName: TypeCostObject?.DedDescription,
                        TypeCostObject: TypeCostObject,
                        DerDocumentNumber: null,
                        AcoID: null,
                        AcoName: account?.CsaDescription,
                        AcoDescription: account?.CsaDescription,
                        DocNumOutput: null,
                        Location1: null,
                        Location2: null,
                        LastPurPrc: 0,
                        OnHand: 0,
                        LastPurCur: "",
                        ConName: null,
                        DerUsrRemoved: null,
                        DerUsrRemovedName: null,
                        GroupAccount: null,
                        DerDayRemoved: null,
                        DerCodeSeal: null,
                        DocNumSap: null,
                        SealCodes: null,
                        OddDescription: consolidatedDescription,
                        OddObservation: consolidatedDescription,
                        OddQuantity: 1,
                        Line: i + 1,
                        OddAccount: account?.CsaAccount,
                        OddAccountName: account?.CsaAccountName,
                        OddUnitPrice: parseFloat(price.toFixed(2)),
                        OddTaxAmount: parseFloat(taxAmount.toFixed(2)),
                        OddAmount: parseFloat(totalAmount.toFixed(2)),
                        OddTaxPercentage: parseFloat(taxPerc.toFixed(2)),
                        TaxCode: 'DMIX_IGV',
                        OddDiscount: parseFloat(discountAmount.toFixed(2)),
                        SecStatus: 1,
                        UsrCreateID: null,
                        PaymentRecords: group.records,
                    }
                });
        },
        async getGuidesTransportReception(HvsID, usrID) {
            try {
                const response = await _sReceptionSurveillance.ListReceptionSurveillanceGang(HvsID, usrID)
                if (response.status == 200 && response.data && response.data.length > 0) {
                    return [...new Set(response.data.flatMap(item => [
                        item.TasPathGngGuideTransportPdf,
                        item.TasPathGngGuideTransportXml,
                        item.TasPathGngGuideTransportMaterialsPdf,
                        item.TasPathGngGuideTransportMaterialsXml
                    ]).filter(file => file && file.trim() !== "")
                    )];
                } else {
                    return [];
                }
            } catch (error) {
                console.error(error);
                return [];
                // this.$fun.alert("Error al obtener las guias de recepción", "error");
            }
        },
        openModal() {
            this.$emit('add');
        },
        formatoMonedaPE(valor) {
            return new Intl.NumberFormat('es-PE', {
                style: 'currency',
                currency: 'PEN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(valor || 0);
        },
        onClose() {
            this.dialogOrder = false;
        },
        clearItemsCard() {
            this.selected = [];
        },
        async syncDetailsWithOrder(event) {
            console.log("Escuchando orden", { event })
            const { Order } = event;
            console.log("Orden", Order)
            if (Order && Order.Detail && Order.Detail.length > 0) {
                // const selecteds = this.processSelectedItems();
                // const allPaymentRecords = [];

                // Order.Detail.forEach(detail => {
                //     const matched = selecteds.find(s => s.OddDescription == detail.OddDescription);

                //     if (matched && matched.PaymentRecords) {
                //         matched.PaymentRecords.forEach(record => {
                //             record.OrdID = detail.OrdID;
                //             record.OddID = detail.OddID;
                //             if (!allPaymentRecords.includes(record)) {
                //                 allPaymentRecords.push(record);
                //             }
                //         });
                //     }
                // });

                const allPaymentRecords = this.selected.map(item => {
                    return {
                        ...item,
                        OrdID: Order.OrdID,
                        // OddID: Order.Detail[0].OddID,
                    }
                });

                console.log("Registros sincronizados:", allPaymentRecords);
                _sPaymentRecordService.saveMassive(allPaymentRecords, this.$fun.getUserID()).then(res => {
                    if (res.status == 200) {
                        this.dialogOrder = false;
                        this.$fun.alert(`Se han sincronizado ${allPaymentRecords.length} registros de pago.`, "success");
                        this.selected = [];
                        this.$refs.gridPaymentRecords.refresh();
                    }
                });
            }
        },
        showOrder(item) {
            console.log('item', item);
            this.reqID = item.OrdID;
            this.dialogOrderView = true;
        },
        async createZipPDFAnexos(guides, invoices, guidesFacele = []) {
            // console.log(JSON.parse(JSON.stringify({ guides, invoices, guidesFacele })))

            const filenameZip = `Anexos-Guias-${Date.now()}`;
            const payload = { filenameZip, guides, invoices, guidesFacele };
            const response = await _sPaymentRecordService.createZipPDFAnexos(payload, this.$fun.getUserID());
            // console.log({ response })

            if (response.status == 200) {

                const contentType = response.headers['content-type'] || '';

                if (contentType.includes('application/json')) {
                    const text = new TextDecoder().decode(response.data);
                    const json = JSON.parse(text);
                    this.$fun.alert(json.message || 'Error al generar el ZIP', "error");
                    return null;
                }

                // response.data ya es ArrayBuffer — no hay riesgo de corrupción

                const blob = new Blob([response.data], { type: 'application/zip' });
                const zipFile = new File([blob], filenameZip + '.zip', { type: 'application/zip' });
                this.order.zipFile = zipFile;
            }

            // Disparar descarga automática
            // const url = window.URL.createObjectURL(blob);
            // const a = document.createElement('a');
            // a.href = url;
            // a.download = fileName;
            // document.body.appendChild(a);
            // a.click();
            // document.body.removeChild(a);
            // window.URL.revokeObjectURL(url);

            // Retornar el File para pre-cargarlo en el modal
            // return zipFile;
        },
        changeWeek(value) {
            // console.log("changeWeek", value);
        },
        restartFilter() {
            this.week = [];
            this.filter.DateEnd = this.$moment().format("YYYY-MM-DD");
            this.filter.DateBegin = this.$moment().format("YYYY-MM-DD");
        },
        downloadPDF(PymReferralGuide) {
            console.log('PymReferralGuide', PymReferralGuide);
            if (PymReferralGuide) {
                _GenUploadFiles.getFile("RutaAnexosSAP", `${PymReferralGuide}`)
                    .then(resp => console.log('downloaded : ', resp))
                    .catch(error => console.error("Error al obtener archivo:", error));
            }
        },
        async getPaginationCenterCostsAsList() {
            const params = {
                filter: { Search: "" }, draw: 1, start: 0, length: -1,
                order: [{ dir: "asc", column: "" }], searchText: "",
            };
            const response = await _sCosteService.pagination(params, this.$fun.getUserID());
            this.allItemsCenterCosts = response.status == 200 ? response.data?.data : [];
            // console.log('allItemsCenterCosts', JSON.parse(JSON.stringify(this.allItemsCenterCosts)));
        },
    },
    created() {
        for (let i = 1; i <= 53; i++) {
            this.itemsWeek.push({
                text: i,
                value: i,
            });
        }

        this.years = this.$fun.getTop5LastYears();
        this.filter.PymYear = this.$moment().year();
        this.restartFilter();
        this.getPaginationCenterCostsAsList();
        // console.log(this.filter)
    },
    watch: {
        PymWeek(value) {
            // console.log({ pymWeek: value })
            this.filter.DateBegin = value ? value.PdsDateBegin : null;
            this.filter.DateEnd = value ? value.PdsDateEnd : null;
            this.filter.PymWeek = value ? value.PdsNum : null;
        },
        "filter.PymYear"() {
            this.week = [];
            this.PymWeek = null;
            this.filter.PymWeek = null;
            this.restartFilter();
        },
    },
};
</script>

<style scoped>
.header-premium {
    background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
    border-bottom: 4px solid #fbbf24;
}

.icon-box {
    background: rgba(255, 255, 255, 0.2);
    padding: 10px;
    border-radius: 12px;
    backdrop-filter: blur(4px);
}

.tracking-tight {
    letter-spacing: -0.025em;
}

.opacity-80 {
    opacity: 0.8;
}

.modern-grid {
    border: 1px solid #e2e8f0 !important;
    background-color: white !important;
}

.no-border-radius-top {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
}

.filter-wrapper {
    border-bottom: 1px solid #edf2f7;
}

.shadow-soft {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05) !important;
}

.border-light {
    border: 1px solid #edf2f7 !important;
}

.bg-slate-50 {
    background-color: #f8fafc;
}

.line-height-1 {
    line-height: 1;
}

.border-sm {
    border: 1px solid rgba(0, 0, 0, 0.08) !important;
}

/* Transiciones suaves */
.v-card {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.search-box-premium {
    background: rgba(255, 255, 255, 0.15) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    max-width: 180px;
    height: 32px;
    transition: all 0.3s ease;
    backdrop-filter: blur(4px);
}

.search-box-premium:focus-within {
    background: rgba(255, 255, 255, 0.25) !important;
    border-color: rgba(255, 255, 255, 0.5) !important;
}

.search-field {
    font-weight: 400;
}

.refresh-btn-glass {
    background: rgba(255, 255, 255, 0.15) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    transition: all 0.3s ease;
    backdrop-filter: blur(4px);
}

.refresh-btn-glass:hover {
    background: rgba(255, 255, 255, 0.25) !important;
    transform: rotate(90deg);
}

.refresh-btn-glass:active {
    transform: rotate(180deg);
}

/* ── Estilos para el Modal Premium ── */
.modal-header-premium {
    background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
    border-bottom: 3px solid #fbbf24;
    position: relative;
    z-index: 10;
}

.header-icon-box {
    background: rgba(255, 255, 255, 0.15);
    padding: 8px;
    border-radius: 12px;
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.glass-modal {
    background: rgba(255, 255, 255, 0.98) !important;
    backdrop-filter: blur(10px);
}

.border-premium-card {
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.modal-content-wrapper {
    max-height: 85vh;
    overflow-y: auto;
    background-color: #f1f5f9;
}

.close-btn-hover {
    transition: all 0.2s ease;
    background: rgba(255, 255, 255, 0.1);
}

.close-btn-hover:hover {
    background: rgba(244, 63, 94, 0.2);
    transform: rotate(90deg);
}

/* Estilo para los headers de la tabla */
::v-deep .v-data-table th {
    background-color: #f1f5f9 !important;
    color: #475569 !important;
    font-weight: 800 !important;
    text-transform: uppercase !important;
    font-size: 0.65rem !important;
    letter-spacing: 0.05em !important;
    height: 48px !important;
    border-bottom: 2px solid #cbd5e1 !important;
}

::v-deep .v-data-table td {
    height: 52px !important;
    font-size: 0.85rem !important;
    color: #334155 !important;
}

::v-deep .v-data-table tr:hover {
    background-color: #f8fafc !important;
}

::v-deep .modern-grid .v-toolbar {
    background-color: white !important;
    border-bottom: 1px solid #f1f5f9 !important;
}

.text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
